// extracted by mini-css-extract-plugin
export default {"PrivacyPage":"PrivacyPage_PrivacyPage__VbQcD","PanelSection":"PrivacyPage_PanelSection__FifNV"};